import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import FullpageWrapper from '@/components/FullpageWrapper';
import IframeContainer from '@/components/IframeContainer';
import { loadLocation, setIsNewsTickerVisible } from '@/state/features/app';
import { useAppDispatch, useAppSelector } from '@/state/store';
import AchievementFeed from '@/components/AchievementFeed';
import FloatingHeaderBar from '@/components/FloatingHeaderBar';
import GuestSignUpModal from '@/components/GuestSignUpModal';
import ProfileDrawer from '@/components/ProfileDrawer';
import MediaViewer from '@/components/MediaViewer';
import NewsTicker from '@/components/NewsTicker';
import InformationDrawer from '@/components/InformationDrawer';
import ExitModal from '@/components/ExitModal';
import { sendEvent } from '@/utils/analytics';
import { pathToURL } from '@/utils/urls';
import { homePath } from '@/theme/vars';
import { useTheme } from '@/theme';

import * as styles from './styles.module.scss';
import ShareModal from '@/components/ShareModal';

export default function LocationPageBasic() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const { location, isLocationLoading, isProfileOpen, isInformationOpen, locationLoadErrorId, shouldHideUi } =
        useAppSelector((state) => state.app);

    const { locationId: id } = useParams();

    useEffect(() => {
        // Redirect if not found
        if (locationLoadErrorId === id) {
            navigate(homePath);
        }
    }, [locationLoadErrorId]);

    useEffect(() => {
        if ((!location || location.id !== id) && !isLocationLoading) dispatch(loadLocation(id));
        sendEvent('open_location', { locationId: id });

        // Reset UI on load
        dispatch(setIsNewsTickerVisible(!!theme.customJSON.shouldNewsTickerShowImmediately));
    }, [id]);

    if (!location || location.id !== id) return <></>;

    const sidebarIsOpen = (isProfileOpen || isInformationOpen) && !shouldHideUi;
    const hasInformationDrawer = theme.customJSON?.informationDrawer?.enabled;
    const arisewareLoadingImageUrl = location.customJSON?.arisewareLoadingImageUrl;

    return (
        <FullpageWrapper pageHasProfileDrawer>
            <div
                className={classNames(styles.contentWrapper, {
                    [styles['contentWrapper--sidebarOpen']]: sidebarIsOpen,
                })}
            >
                <IframeContainer
                    forceInFrontOfUi={shouldHideUi}
                    src={location.iframeURL || location.latestArisewareBuildURL}
                    arisewareProjectID={location.arisewareProjectID}
                    onReady={() => {}}
                    loadingImage={arisewareLoadingImageUrl ? arisewareLoadingImageUrl : null}
                    loadingText={theme.metadata?.customJSON?.loadingText}
                />
                {!process.env.PUBLIC_TEMP_HIDE_UI && <NewsTicker />}
                {!process.env.PUBLIC_TEMP_HIDE_UI && <FloatingHeaderBar />}
            </div>
            <div
                className={classNames(styles.sidebarWrapper, {
                    [styles['sidebarWrapper--sidebarOpen']]: sidebarIsOpen,
                })}
            >
                <ProfileDrawer />
                {hasInformationDrawer && <InformationDrawer />}
            </div>
            <MediaViewer />
            <AchievementFeed />
            <GuestSignUpModal />
            <ShareModal />
            <ExitModal />
        </FullpageWrapper>
    );
}
